/**
 * FILE MUST NOT BE CHANGED WITHOUT QA TEAM APPROVAL
 *
 * FOR MORE DETAILS SEE
 * ```scr/researcher/constants/xpath.constants.ts```
 */

interface XPathProps {
  'data-testid'?: string;
  'data-region'?: string;
}
export const CitationGeneratorXPath = {
  // citation source switch button
  CitationSourceSelect: {
    'data-testid': 'citation_results/select_source',
  } as XPathProps,
  // citation sources list popover
  CitationSourceSelectPopover: {
    'data-testid': 'citation_results/select_source_popover',
  } as XPathProps,
  // compose or create
  ComposeCitation: {
    'data-testid': 'citation_results/compose_citation',
  } as XPathProps,

  MoreCitationCardOptions: {
    'data-testid': 'citation_list/citation_card/more_options',
  } as XPathProps,
  // more citation popover options
  MoreCitationCardOptionPopover: {
    'data-testid': 'citation_list/citation_card/more_options_popover',
  } as XPathProps,
  EditFormTitleInput: {
    'data-testid': 'citation_edit_form/source_title',
  } as XPathProps,
};
